// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604200933/js/" + chunkId + "." + {"44":"753a7068","225":"f50dc14a","481":"04c22a68","486":"1db0b368","770":"9bb53ba0"}[chunkId] + ".0.736141503078078.chunk.js";
};